/* Camp Hallow · drawer: botões da oferta (data-ch-lines) + prazo de entrega.
   Usa Shopify.actions.updateCart, que dispara o evento que o Horizon escuta e redesenha o drawer. */
(function () {
  if (window.__chCart) return;
  window.__chCart = true;

  function addBiz(d, n) {
    d = new Date(d);
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  // política: despacho 1-2 dias úteis + entrega 5-12 dias úteis
  function fillEta(root) {
    (root || document).querySelectorAll('[data-ch-eta]').forEach(function (el) {
      var now = new Date(), lo = addBiz(now, 6), hi = addBiz(now, 14);
      var f = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
      var range = el.querySelector('[data-eta-range]'), txt = f(lo) + ' – ' + f(hi);
      if (!el.hidden && range.textContent === txt) return;
      range.textContent = txt;
      var hw = new Date(now.getFullYear(), 9, 31, 23, 59);
      var tag = el.querySelector('[data-eta-hw]');
      if (tag) tag.hidden = !(hi <= hw && now <= hw);
      el.hidden = false;
    });
  }

  async function legacy(lines) {
    var updates = {}, add = [];
    lines.forEach(function (l) { if (l.id) updates[l.id] = l.quantity; else add.push({ id: +l.merchandiseId, quantity: l.quantity }); });
    if (Object.keys(updates).length) await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
    if (add.length) await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: add }) });
    location.reload();
  }

  async function apply(lines, btn) {
    btn.disabled = true; btn.classList.add('is-busy');
    var done = false;
    try {
      var act = window.Shopify && window.Shopify.actions && window.Shopify.actions.updateCart;
      if (!act) return await legacy(lines);
      // adiciona primeiro; só tira a peça antiga depois que o set entrou (se faltar estoque, o cliente não perde nada)
      var upd = lines.filter(function (l) { return l.id; }), add = lines.filter(function (l) { return !l.id; });
      if (add.length) { var b = await act({ lines: add }); if (b && b.userErrors && b.userErrors.length) throw new Error(b.userErrors[0].message); done = true; }
      if (upd.length) { var a = await act({ lines: upd }); if (a && a.userErrors && a.userErrors.length) throw new Error(a.userErrors[0].message); }
    } catch (e) {
      console.error('[ch-cart]', e);
      if (done) return location.reload();
      try { await legacy(lines); } catch (_) { btn.disabled = false; btn.classList.remove('is-busy'); }
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ch-lines]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var lines; try { lines = JSON.parse(b.getAttribute('data-ch-lines')); } catch (_) { return; }
    apply(lines, b);
  });

  // O Horizon mede o rodapé uma vez, às vezes antes do conteúdo chegar (1º item no carrinho vazio)
  // e o checkout fica fora da tela. Remede sempre que o conteúdo ou o tamanho mudar (mesma regra: até 50%).
  var raf = 0, ro = null, watched = null;
  function sticky() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      var dlg = document.querySelector('#cart-drawer dialog');
      if (!dlg) return;
      var s = dlg.querySelector('.cart-drawer__summary');
      if (!s || !dlg.querySelector('.cart-drawer__content')) return;
      if (ro && watched !== s) { ro.disconnect(); ro.observe(s); watched = s; }
      var dh = dlg.getBoundingClientRect().height, sh = s.getBoundingClientRect().height;
      if (!dh || !sh) return;
      var v = sh / dh > 0.5 ? 'false' : 'true';
      if (dlg.getAttribute('cart-summary-sticky') !== v) dlg.setAttribute('cart-summary-sticky', v);
    });
  }

  // contagem regressiva do Halloween na barra (hora do visitante; 31/10 00:00)
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tickHalloween() {
    var now = new Date(), end = new Date(now.getFullYear(), 9, 31, 0, 0, 0), s = Math.floor((end - now) / 1000);
    document.querySelectorAll('[data-ch-cd]').forEach(function (el) {
      if (s > 0) { var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
        el.textContent = d + 'd ' + pad(h) + 'h ' + pad(m) + 'm ' + pad(x) + 's'; }
      else if (now.getMonth() === 9 && now.getDate() === 31) { var p = el.closest('.ch-hw'); if (p) p.textContent = 'Halloween is tonight'; }
    });
  }

  // ch-gallery-video: galeria troca de foto a cada 4s; se a pessoa der play num vídeo, para de trocar
  function stopGallery(e) {
    var t = e.target; if (!t || !t.closest) return;
    if (e.type === 'click' && !t.closest('deferred-media, [class*="--video"], [class*="--external_video"], [class*="--model"]')) return;
    var s = t.closest('slideshow-component[autoplay]'); if (s && typeof s.pause === 'function') s.pause();
  }
  document.addEventListener('play', stopGallery, true);
  document.addEventListener('click', stopGallery, true);

  function boot() {
    tickHalloween(); setInterval(tickHalloween, 1000);
    fillEta();
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    if ('ResizeObserver' in window) ro = new ResizeObserver(sticky);
    new MutationObserver(function () { fillEta(drawer); sticky(); }).observe(drawer, { childList: true, subtree: true });
    window.addEventListener('resize', sticky);
    drawer.addEventListener('theme-drawer:open', sticky);
    sticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
